const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8080').replace(/\/$/, '');

async function readApiError(response) {
  try {
    const data = await response.json();
    return data.error || data.message || `Request failed (${response.status})`;
  } catch (error) {
    return `Request failed (${response.status})`;
  }
}

export async function createOrder({ planId, name, email, mobile }) {
  const response = await fetch(`${API_URL}/api/create-order.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      plan_id: planId,
      name,
      email,
      mobile,
    }),
  });

  if (!response.ok) {
    throw new Error(await readApiError(response));
  }

  const data = await response.json();
  if (!data.ok || !data.order_id) {
    throw new Error(data.error || 'Could not create payment order.');
  }

  return data;
}

export async function verifyPayment({ orderId, paymentId, signature }) {
  const response = await fetch(`${API_URL}/api/verify-payment.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      razorpay_order_id: orderId,
      razorpay_payment_id: paymentId,
      razorpay_signature: signature,
    }),
  });

  if (!response.ok) {
    throw new Error(await readApiError(response));
  }

  const data = await response.json();
  if (!data.ok) {
    throw new Error(data.error || 'Payment verification failed.');
  }

  return data;
}

export function loadRazorpay() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) {
      resolve(window.Razorpay);
      return;
    }

    const existing = document.querySelector('script[data-razorpay-checkout="true"]');
    if (existing) {
      existing.addEventListener('load', () => resolve(window.Razorpay), { once: true });
      existing.addEventListener('error', () => reject(new Error('Failed to load Razorpay.')), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.dataset.razorpayCheckout = 'true';
    script.onload = () => resolve(window.Razorpay);
    script.onerror = () => reject(new Error('Failed to load Razorpay.'));
    document.body.appendChild(script);
  });
}

export function openRazorpayCheckout(options) {
  const RazorpayCheckout = window.Razorpay;
  if (!RazorpayCheckout) {
    throw new Error('Razorpay is not ready.');
  }

  const checkout = new RazorpayCheckout(options);
  checkout.open();
  return checkout;
}
